import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import {
    Grid,
    IconButton,
    Link,
    Typography,
    TextField,
    MenuItem,
    Tooltip,
    Box,
    CircularProgress
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { toggleShowDialog } from '../../store/actions/dialog';
import { atualizarEstadoPedido, getVendasEmAndamento } from '../../store/actions/vendas';
import { getUsuario } from '../../store/actions/usuario';
import { estadosDoPedido } from '../../assets/js/constants';
import TituloPagina from '../../components/layout/TituloPagina';
import moedaBr from '../../assets/js/moedaBr';
import formatarDataHora from '../../assets/js/formatarDataHora';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import normalizarTitulo from '../../assets/js/normalizarTitulo';

const VendasEmAndamento = props => {
    const history = useHistory();
    const {
        vendas,
        usuario,
        getVendasEmAndamento,
        atualizarEstadoPedido,
        negocioDoUsuario,
        loading
    } = props
    const [toggleInformacoesUsuarioDialog, setToggleInformacoesUsuarioDialog] = useState(false);
    const [toggleAtualizarEstadoPedidoDialog, setToggleAtualizarEstadoPedidoDialog] = useState(false);
    const [novoEstadoPedido, setNovoEstadoPedido] = useState('');
    const [variacoesParaAlterarEstado, setVariacoesParaAlterarEstado] = useState([]);
    const [variacaoParaNovoEstado, setVariacaoParaNovoEstado] = useState('');
    const [estadoAtual, setEstadoAtual] = useState('');
    const [instanteEstadoAtual, setInstanteEstadoAtual] = useState('');

    const columns = [
        {
            name: 'Pedido Global',
            selector: (row) => row.pedidoId,
            center: 'true',
            sortable: true,
            width: '150px'
        },
        {
            name: 'Meu Pedido',
            selector: (row) => row.subPedidoId,
            center: 'true',
            sortable: true,
            width: '150px'
        },
        {
            name: 'Data/Hora',
            selector: (row) => row.instantePedido,
            sortable: true,
        },
        {
            name: 'Total do Pedido',
            selector: (row) => moedaBr(row.valorTotalBruto - row.valorTotalDesconto),
            sortable: true,
            width: '150px'
        },
        {
            name: 'Forma Pgto',
            selector: (row) => row.metodoPagamento === 'CARD' ? 'Cartão de Crédito' : normalizarTitulo(row.metodoPagamento),
            sortable: true,
            width: '200px'
        },
        {
            name: 'Status Pgto',
            selector: (row) => row.statusPagamento,
            sortable: true,
            width: '150px'
        },
        {
            name: 'Status Entrega',
            selector: (row) => row.statusEntrega,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <Tooltip title='Detalhar Pedido' placement='right'>
                    <IconButton style={{ padding: 1 }} aria-label="visualizar" size='small' color='secondary' onClick={() => handleDetalhesDaVenda(row.subPedidoId)}><SearchIcon /></IconButton>
                </Tooltip>
            ),
            width: '100px'
        }
    ];

    useEffect(() => {
        getVendasEmAndamento(negocioDoUsuario);
    }, [getVendasEmAndamento, negocioDoUsuario]);

    const handleDetalhesDaVenda = (id) => {
        history.push({
            pathname: '/detalhar-venda',
            state: {
                pedidoVendedorId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleEstadoPedido = (variacao) => {
        if (!variacao || typeof variacao !== 'object') {
            return [];
        }
        const array = Object.entries(variacao).map(([chave, valor]) => ({ [chave]: valor }));
        return Array.isArray(array) ? array.map(v => v) : [];
    }

    const handleAtualizarEstadoPedido = (pedido) => {
        const { produtos } = pedido;
        let array = [];
        produtos.forEach(p => {
            const { variacoes } = p;
            variacoes.forEach(v => {
                array = [...array, {
                    idVariacao: v.id,
                    nomeProduto: p.nomeProduto,
                    tamanho: v.tamanho,
                    estampa: v.estampa,
                    cor: v.cor,
                    estadoPedidoProduto: v.estadoPedidoProduto,
                    codigoEstadoPedidoProduto: v.codigoEstadoPedidoProduto,
                    instanteEstado: v.instanteEstado
                }];
            });
        })
        setEstadoAtual('');
        setInstanteEstadoAtual('');
        setNovoEstadoPedido('');
        setVariacaoParaNovoEstado('');
        setVariacoesParaAlterarEstado(array);
        setToggleAtualizarEstadoPedidoDialog(true);
    }

    const handleConfirmarNovoEstadoPedido = () => {
        const pedidoAtualizado = {
            idVendedor: negocioDoUsuario,
            idVariacao: variacaoParaNovoEstado,
            codigoEstadoPedido: novoEstadoPedido
        }
        atualizarEstadoPedido(pedidoAtualizado);
        setToggleAtualizarEstadoPedidoDialog(false);
    }

    const handleEstadoAtual = (idVariacao) => {
        const variacao = variacoesParaAlterarEstado.find(v => v.idVariacao === idVariacao);

        if (variacao) {
            setEstadoAtual(variacao.estadoPedidoProduto);
            setInstanteEstadoAtual(variacao.instanteEstado);
        }
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Vendas em Andamento' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={vendas}
                />
            </Box>
            <DialogAlert title='Informações de Usuário'
                fullWidth={true}
                maxWidth='sm'
                cancelButtonClick={() => setToggleInformacoesUsuarioDialog(false)}
                labelCancelButton='Fechar'
                cancelButton={true}
                openDialog={toggleInformacoesUsuarioDialog}
            >
                <Grid container item style={{ paddingTop: '15px' }}>
                    <Grid item xs >
                        <Typography variant="subtitle1" style={{ color: '#424242' }}>Nome</Typography>
                        <Typography variant="body1" >{usuario.nome} {usuario.sobreNome}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#424242' }} >Endereço para entrega</Typography>
                        <Typography variant="body1" ></Typography>
                    </Grid>
                </Grid>
            </DialogAlert>

            <DialogAlert
                title='Alterar Estado de Pedido'
                fullWidth={true}
                maxWidth='sm'
                okButton={true}
                okButtonType='submit'
                okButtonClick={() => handleConfirmarNovoEstadoPedido()}
                labelOkButton='Confirmar'
                cancelButton={true}
                cancelButtonClick={() => setToggleAtualizarEstadoPedidoDialog(false)}
                labelCancelButton='Cancelar'
                openDialog={toggleAtualizarEstadoPedidoDialog}
            >
                <Grid container item style={{ paddingTop: '15px' }}>
                    <Grid item xs >
                        <Typography variant="subtitle1" style={{ color: '#999997' }}>Selecione o produto e depois novo estado.</Typography>
                        <Grid item sx style={{ padding: '5px' }}>
                            <TextField
                                select
                                fullWidth
                                id="produtoNovoEstado"
                                label="Produto"
                                variant="filled"
                                value={variacaoParaNovoEstado}
                                onChange={(event) => {
                                    setVariacaoParaNovoEstado(event.target.value);
                                    handleEstadoAtual(event.target.value);
                                }}>
                                <MenuItem key='default' value='' >Selecione um produto</MenuItem>
                                {
                                    variacoesParaAlterarEstado.map(v =>
                                    (
                                        <MenuItem key={v.idVariacao} value={v.idVariacao} >
                                            {v.nomeProduto}
                                            {v.tamanho !== 'Não se aplica' ? ` ${v.tamanho}` : null}
                                            {v.estampa !== 'Não se aplica' ? ` ${v.estampa}` : null}
                                            {v.cor !== 'Não se aplica' ? ` ${v.cor}` : null}
                                        </MenuItem>
                                    )
                                    )
                                }
                            </TextField>
                        </Grid>
                        <Grid item sx style={{ padding: '5px' }}>
                            {estadoAtual !== ''
                                ?
                                <Typography>Estado atual: <strong>{estadoAtual}</strong> em {formatarDataHora(instanteEstadoAtual)}</Typography>
                                :
                                null
                            }
                        </Grid>
                        <Grid item sx style={{ padding: '5px' }}>
                            <TextField
                                select
                                fullWidth
                                id="novoEstadoPedido"
                                label="Estados do Pedido"
                                variant="filled"
                                value={novoEstadoPedido}
                                onChange={(event) => {
                                    setNovoEstadoPedido(event.target.value);
                                }}>
                                <MenuItem key='default' value='' >Selecione uma opção</MenuItem>
                                {estadosDoPedido?.map((option) => (
                                    <MenuItem key={option.id} value={option.id} >{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogAlert>

        </>
    )
}

const mapStateToProps = state => (
    {
        vendas: state.venda.vendas,
        usuario: state.usuario.usuario,
        idDialogShow: state.dialog.idDialogShow,
        venda: state.venda.venda,
        loading: state.venda.loading,
        negocioDoUsuario: state.negocio.negocioDoUsuario
    })
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        toggleShowDialog,
        getVendasEmAndamento,
        getUsuario,
        atualizarEstadoPedido,
    }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(VendasEmAndamento)